import React from 'react';
import { motion } from 'framer-motion';
interface SectionRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function SectionReveal({
  children,
  className = '',
  delay = 0
}: SectionRevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5,
    delay
  }} className={className} data-id="element-236" data-mp="1gg8kpk5xvtpl">
      {children}
    </motion.div>;
}